import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Tabs, Tab, Box, InputAdornment, Switch } from "@mui/material";
// components
import Page from "src/components/Page";
import { alert } from "src/services/alert";
import { COMP_NAME } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { useSelector } from "react-redux";
// import { getProductCategories } from "src/services/request";
import NavBack from "src/components/common/NavBack";
import { getAreas, getMerchantCategories } from "src/services/request";
import AddressPicker from "src/components/common/AddressPicker";
import { asyncRequest } from "src/services/network";
import Cascader from "src/components/cascader/Cascader";

export default function MerchantDetail() {
  const { merchantCategories, areas, areaHierarchy } = useSelector((state) => state.globalData);

  const navigate = useNavigate();
  const item = useLocation().state || {};
  const { mid } = useParams();
  const [category, setCategory] = useState({});
  const [detail, setDetail] = useState(item.detail);
  const [address, setAddress] = useState({
    address: item.address
  });

  const [area, setArea] = useState('');

  // console.log('merchantCategories', merchantCategories)

  const [form, setForm] = useState({
    mid: 0,
    mobile: item.mobile || "",
    name: item.name || "",
    logo: item.logo || "",
    background: item.background || "",
    images: item.images || "",
    username: item.username || "",
    password: item.password || "",
    realname: item.realname || "",
    license: item.license || "",
    intro: item.intro || "",
    // 地理信息
    province: item.province || "",
    city: item.city || "",
    district: item.district || "",
    address: item.address || "",
    isZhiyin: item.isZhiyin || false,
    lng: item.lng || "",
    lat: item.lat || "",

    hfUid: item.hfUid || "",
    provinceId: item.provinceId || null,
    cityId: item.cityId || null,
    districtId: item.districtId || null,

    status: item.status || 1,
    order: item.order || 0,
    rangli: item.rangli || 20,
    discount: item.discount || 10,
  });

  useEffect(() => {
    getAreas();
    getMerchantCategories();
  }, []);

  useEffect(() => {
    if (!merchantCategories.length || !item.categoryId) return;

    setCategory(merchantCategories.find(it => it.id == item.categoryId) || {});
  }, [merchantCategories])

  useEffect(() => {
    if (!areas) return;
    if (!form.provinceId) return
    const province = areas.find(area => area.id === form.provinceId);
    const city = areas.find(area => area.id === form.cityId);
    const qu = areas.find(area => area.id === form.districtId);
    setArea(`${province.name}${city.name}${qu.name}`)
  }, [areas, form.districtId])

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleSubmit() {
    if (!mid && !category.id) return alert("请选择分类");
    if (!mid && !address) return alert("请选择地址");
    const { name, username, password } = form;

    const formData = {
      ...form,
      categoryId: category.id,
      ...address,
    };

    if (mid) {
      formData.mid = mid;

      delete formData.username;
      delete formData.password;
    }

    // return console.log(formData);

    const { data } = await asyncRequest({
      path: mid ? "/merchant/edit" : "/merchant/add",
      data: formData,
    });

    navigate(-1, { replace: true });
  }

  console.log(form.address);

  return (
    <>
      <Page title={`${mid ? "编辑" : "添加"}商户 | ${COMP_NAME}`}>
        <Container maxWidth="2000px">
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <NavBack title={`${mid ? "编辑" : "添加"}商户`} />
          </Stack>

          <Paper variant="outlined" sx={{ py: 2, px: 2 }}>
            <Box>
              <FormItem title="商户分类">
                <Select value={category} onChange={(e) => setCategory(e.target.value)} style={{ width: 250, height: 44 }}>
                  {merchantCategories.map((category, idx) => (
                    <MenuItem key={category.id} value={category} name={category.name}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormItem>

              <FormItem title="是否直营" required>
                <Switch placeholder="请输入商户名称" autoComplete="off" id="isZhiyin" checked={form.isZhiyin} onChange={(e) => handleIptChange("isZhiyin", e.target.checked)} />
              </FormItem>

              <FormItem title="商户名称" required>
                <TextField fullWidth placeholder="请输入商户名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
              </FormItem>
              {/* 
            <FormItem title="商户单位" required>
              <TextField placeholder="请输入商户单位" autoComplete="off" id="unit" value={form.unit} size="small" onChange={(e) => handleIptChange("unit", e.target.value)} />
            </FormItem> */}

              <FormItem title="商户logo" required>
                <Stack>
                  <Uploader images={form.logo} onUploaded={(val) => handleIptChange("logo", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：200x200
                  </Typography>
                </Stack>
              </FormItem>

              <FormItem title="商户背景图" required>
                <Stack>
                  <Uploader images={form.background} onUploaded={(val) => handleIptChange("background", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：750x360
                  </Typography>
                </Stack>
              </FormItem>

              <FormItem title="商户轮播图" required>
                <Stack>
                  <Uploader multiple images={form.images} onUploaded={(val) => handleIptChange("images", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：400x400
                  </Typography>
                </Stack>
              </FormItem>

              <FormItem title="营业执照" required>
                <Stack>
                  <Uploader images={form.license} onUploaded={(val) => handleIptChange("license", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：500x300
                  </Typography>
                </Stack>
              </FormItem>

              <FormItem title="商户状态" required>
                <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
                  <FormControlLabel value={1} control={<Radio />} label="启用" onChange={(e) => handleIptChange("status", e.target.value)} />
                  <FormControlLabel value={2} control={<Radio />} label="停用" onChange={(e) => handleIptChange("status", e.target.value)} />
                </RadioGroup>
              </FormItem>

              <FormItem title="微信支付商户号">
                <TextField placeholder="请输入微信支付商户号" autoComplete="off" id="hfUid" value={form.hfUid} size="small" onChange={(e) => handleIptChange("hfUid", e.target.value.trim())} />
              </FormItem>

              <FormItem title="让利百分比" required>
                <TextField
                  type="number"
                  placeholder="请输入让利百分比"
                  autoComplete="off"
                  id="rangli"
                  value={form.rangli}
                  size="small"
                  onChange={(e) => handleIptChange("rangli", e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                  }}
                />
              </FormItem>

              <FormItem title="折扣" required>
                <TextField
                  type="number"
                  placeholder="请输入折扣，最低2折"
                  autoComplete="off"
                  id="discount"
                  value={form.discount}
                  size="small"
                  onChange={(e) => handleIptChange("discount", e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">折</InputAdornment>,
                  }}
                />
              </FormItem>

              

              {!mid && (
                <>
                  <FormItem title="登陆账号" required>
                    <TextField fullWidth placeholder="登陆账号" autoComplete="off" id="username" value={form.username} size="small" onChange={(e) => handleIptChange("username", e.target.value)} />
                  </FormItem>

                  <FormItem title="登录密码" required>
                    <TextField fullWidth placeholder="登录密码" type="password" autoComplete="off" id="password" value={form.password} size="small" onChange={(e) => handleIptChange("password", e.target.value)} />
                  </FormItem>
                </>
              )}

              <FormItem title="手机号" required>
                <TextField fullWidth placeholder="手机号" type="number" autoComplete="off" id="mobile" value={form.mobile} size="small" onChange={(e) => handleIptChange("mobile", e.target.value)} />
              </FormItem>

              <FormItem title="姓名" required>
                <TextField fullWidth placeholder="姓名" autoComplete="off" id="realname" value={form.realname} size="small" onChange={(e) => handleIptChange("realname", e.target.value)} />
              </FormItem>

              <AddressPicker
                address={address.address}
                onChange={(v) => {
                  setAddress(v);
                  // handleIptChange("address", v.address);
                }}
              />

              <FormItem title="所属地区">
                <TextField disabled value={area} />

                {!!areas && (
                  <Cascader
                    options={areaHierarchy}
                    kiLabel="name"
                    onSelect={(v) => {
                      setForm({
                        ...form,
                        provinceId: v[0].value,
                        cityId: v[1].value,
                        districtId: v[2].value,
                      });
                    }}
                  />
                )}
              </FormItem>

              <FormItem title="排序">
                <TextField type="number" placeholder="请输入排序" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
              </FormItem>

              <FormItem spacing={1}>
                <Button variant="contained" type="submit" onClick={handleSubmit}>
                  确认{mid ? "修改" : "添加"}
                </Button>
              </FormItem>
            </Box>
          </Paper>
        </Container>
      </Page>
    </>
  );
}
